/* Activated Intuition Gift Finder — dynamic collections and group navigation. */
(() => {
  if (window.__aiGiftFinderNavigation) return;
  window.__aiGiftFinderNavigation = true;
  let requestId = 0;
  const finderSelector = '[class*="ai-gift-finder-"][class*="__shell"]';
  const linkSelector = 'a[class*="ai-gift-finder-"][class*="__pill"], a[class*="ai-gift-finder-"][class*="__show-all"]';
  const gridSelector = 'results-list[section-id]';
  const groupHandles = { 'gifts-by-occasion': 1, 'gifts-by-interest': 2, 'gifts-by-zodiac': 3, 'gift-an-experience': 5 };
  function finder() { return document.querySelector(finderSelector)?.parentElement || null; }
  function updateSelection(url, link, groupIndex) {
    const root = finder();
    if (!root) return;
    const handle = url.pathname.split('/').filter(Boolean).pop();
    root.querySelectorAll(linkSelector).forEach(a => {
      if (a === link || (!link && new URL(a.href, location.origin).pathname === url.pathname)) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
    const group = groupIndex || groupHandles[handle];
    if (group) {
      const tab = root.querySelector('[data-ai-group="' + group + '"]');
      if (tab) {
        root.querySelectorAll('[role="tab"]').forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panelId = item.getAttribute('aria-controls');
          const panel = panelId ? root.querySelector('#' + CSS.escape(panelId)) : null;
          if (panel) panel.hidden = !active;
        });
      }
    }
  }
  async function navigate(href, link, push = true, groupIndex = null) {
    const grid = document.querySelector(gridSelector);
    if (!grid) { location.assign(href); return; }
    const token = ++requestId;
    const url = new URL(href, location.origin);
    const target = url.pathname + url.search + url.hash;
    grid.setAttribute('aria-busy','true');
    try {
      const gridParams = new URLSearchParams(url.search);
      gridParams.set('section_id', grid.getAttribute('section-id'));
      const response = await fetch(url.pathname + '?' + gridParams.toString(), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Grid request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.querySelector(gridSelector);
      if (!nextGrid) throw new Error('Collection grid unavailable');
      if (token !== requestId) return;
      grid.replaceWith(nextGrid);
      if (push) history.pushState({ aiGiftFinder: true }, '', target);
      updateSelection(url, link, groupIndex);
      const root = finder();
      const detail = nextGrid.querySelector('[data-ai-collection-details]');
      if (root && detail) {
        const shell = root.querySelector('[class*="__shell"]');
        const previous = shell?.querySelector('[class*="__description"]');
        const showDescription = root.dataset.aiShowCollectionDescription !== 'false';
        const showTitle = root.dataset.aiShowCollectionTitle === 'true';
        const body = detail.querySelector('[data-ai-collection-body]');
        if (previous) previous.remove();
        if (shell && showDescription && body && body.innerHTML.trim()) {
          const prefix = [...root.classList].find(c => /^ai-gift-finder-[^_]+$/.test(c));
          if (prefix) {
            const description = document.createElement('section');
            description.className = prefix + '__description';
            description.setAttribute('aria-label', 'About ' + (detail.dataset.aiCollectionTitle || 'collection'));
            if (showTitle) {
              const heading = document.createElement('h3');
              heading.textContent = detail.dataset.aiCollectionTitle || '';
              description.appendChild(heading);
            }
            const rich = document.createElement('div');
            rich.className = 'rte';
            rich.innerHTML = body.innerHTML;
            description.appendChild(rich);
            shell.appendChild(description);
          }
        }
      }
      document.dispatchEvent(new CustomEvent('ai:gift-finder:collection-change', { detail: { url: target } }));
    } catch (err) {
      if (token === requestId) location.assign(target);
    } finally {
      if (token === requestId) document.querySelector(gridSelector)?.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.(linkSelector);
    if (link && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && link.target !== '_blank') {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname.startsWith('/collections/')) {
        event.preventDefault();
        navigate(link.href, link);
      }
      return;
    }
    const tab = event.target.closest?.('[data-ai-group-url][role="tab"]');
    if (tab && tab.closest(finderSelector) && !event.defaultPrevented) {
      const url = tab.dataset.aiGroupUrl;
      if (url) navigate(url, null, true, Number(tab.dataset.aiGroup));
    }
  });
  window.addEventListener('popstate', () => {
    if (finder()) navigate(location.href, null, false);
  });
})();